import dayjs from "dayjs";
import { FixedArray } from "utils/FixedArray";

export type DayjsWeek = FixedArray<dayjs.Dayjs, 7>;

export const calendarWeek = (searchDate: string): DayjsWeek => {
  const week = [];
  const searchDay = dayjs(searchDate);
  const sundayPrior = searchDay.startOf("week");
  let start = sundayPrior;
  const saturdayAfter = searchDay.endOf("week");
  while (start.isBefore(saturdayAfter)) {
    week.push(start);
    start = start.add(1, "day");
  }
  return week as DayjsWeek;
};

export const calendarWeekV2 = (searchDate: string): DayjsWeek => {
  const week: any[] = [];
  ["0", "1", "2", "3", "4", "5", "6"].map((i) =>
    week.push(dayjs(searchDate).add(parseInt(i), "day"))
  );
  return week as DayjsWeek;
};

export const getPreviousScheduleDate = (
  searchDate: string,
  visibleDayCount: number
): string => {
  const today = dayjs().startOf("day");
  const previousDate = dayjs(searchDate).subtract(visibleDayCount, "day");
  return (previousDate.isBefore(today) ? today : previousDate).format(
    "YYYY-MM-DD"
  );
};

export const getScheduleDays = () => {
  const getScheduleDays = [];
  for (let i = 0; i <= 50; i++) {
    getScheduleDays[dayjs().add(i, "day").format("YYYY-MM-DD")] = [];
  }
  return getScheduleDays;
};

export const getNextAvailableDate = (
  doctorId: any,
  startDate: any,
  newDateArr: any,
  newDateRange: any
) => {
  let returnData = [0, "", startDate];
  for (const keyAvail in newDateRange) {
    if (dayjs(keyAvail).isAfter(startDate)) {
      if (
        typeof newDateArr[startDate] !== "undefined" &&
        typeof newDateArr[startDate][doctorId] !== "undefined"
      ) {
        returnData = [
          newDateArr[startDate][doctorId][0],
          "nextavailable",
          startDate,
        ];
        break;
      }
      startDate = dayjs(startDate).add(1, "day").format("YYYY-MM-DD");
    }
  }
  return returnData;
};

export const updateQueryParam = (key: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  return `${url.pathname}${url.search}`;
};
